import router from "../../router";
import Vue from "vue";
export default {
    namespaced: true,
    state: {
        isLoggedIn: false,
        currentUser: null,
        emailLogin: '',
        preAuthToken: null
    }, // = data
    getters: {
        currentUser(state) {
            return state.currentUser;
        },
        isLoggedIn(state) {
            return state.isLoggedIn;
        },
        emailLogin(state) {
            return state.emailLogin;
        },
        preAuthToken(state) {
            return state.preAuthToken;
        }
    }, // = computed
    mutations: {
        setCurrentUser(state, currentUser) {
            state.currentUser = currentUser;
            state.isLoggedIn = true;
        },
        login(state, token) {
            window.$cookies.set("jwt", token, "14d");
            window.$cookies.set("_time", Date.now());
            state.isLoggedIn = true;
        },
        logout(state) {
            window.$cookies.remove("jwt");
            window.$cookies.remove("_time");
            state.currentUser = null;
            state.isLoggedIn = false;
            state.preAuthToken = null;
            router.replace("/login");
        },
        setMyEmail(state, emailLogin) {
            state.emailLogin = emailLogin;
        },
        setPreAuthToken(state, token) {
            state.preAuthToken = token;
        },
        clearPreAuthToken(state) {
            state.preAuthToken = null;
        }
    }, // change state here
    actions: {
        login({ commit }, token) {
            commit("login", token);
        },
        setCurrentUser({ commit }, callback) {
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get("/users/profile")
                    .then(res => {
                        if (res.data.statusCode !== 200) {
                            commit("logout");
                        } else {
                            commit("setCurrentUser", res.data.data);
                            if (typeof callback === "function") callback();
                        }
                        resolve();
                    })
                    .catch(err => reject(err));
            });
        },
        logout({ commit }) {
            commit("logout");
        },
        setMyEmail({ commit }, emailLogin) {
            commit("setMyEmail", emailLogin);
        },
        setPreAuthToken({ commit }, token) {
            commit("setPreAuthToken", token);
        },
        clearPreAuthToken({ commit }) {
            commit("clearPreAuthToken");
        }
    } // = method active mutations
};
